/* eslint-disable @typescript-eslint/no-unused-vars */
import { CloudinaryImage } from "@/lib/constants/cloudinary";
import RoomInfo, { RoomInfoProps } from "./RoomInfo";
import { useTranslation } from "@/lib/i18n/client";
import Text from "../Text";
import { BadgesProps } from "./Badges";
// import Badges, { BadgesProps } from "./Badges";
import { Coordinates } from "@/lib/types/Map";
import { classNames } from "@/lib/utils/general";
import { getUrl, Urls } from "@/lib/constants/urls";
import { useQueryParams } from "@/lib/hooks/useQueryParams";
import CloudImage from "../CloudImage";
import { cloudinaryCoyotivLoader } from "@/lib/setup/cloudinaryLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/pro-solid-svg-icons";

export type RoomProps = {
    roomId: string;
    rating: number;
    category: string;
    pricePerMonth: number;
    originalPricePerMonth?: number;
    title?: string;
    address: string;
    className?: string;
    images: CloudinaryImage[];
    slug: string;
    fixedSlug: string;
    location: Coordinates;
    companyId?: string;
} & RoomInfoProps &
    BadgesProps;

const MobileMapRoom = ({
                           roomId,
                           rating,
                           isInstantBooking,
                           isFeatured,
                           isSuperHost,
                           pricePerMonth,
                           originalPricePerMonth = undefined,
                           // title,
                           address,
                           lang,
                           images,
                           category,
                           className = "",
                           numGuests,
                           numBedrooms,
                           hasKitchen,
                           numBeds,
                           numBaths,
                           companyId,
                       }: RoomProps) => {
    const { t } = useTranslation(lang, "search");
    const itemBottomCss = "flex flex-row items-baseline";
    const currencyStyle: Intl.NumberFormatOptions = { style: "currency", currency: "EUR", minimumFractionDigits: 0 };

    const PricewithCurrencySymbol = Math.round(pricePerMonth / 100).toLocaleString("de-DE", currencyStyle);
    const PricewithoutCurrencySymbol = Math.round(pricePerMonth / 100).toLocaleString("de-DE");
    const CurrencySymbol = PricewithCurrencySymbol.charAt(PricewithCurrencySymbol.length - 1);

    const searchUrlParams = useQueryParams();

    const openRoomDetails = () => {
        searchUrlParams.set("roomId", roomId);
        window.open(getUrl(Urls.room.index, lang, {}, searchUrlParams.toString()), "_blank");
    };

    const img = images[0];

    return (
        <div
            className={classNames(
                "rounded-md grow h-full grid grid-cols-10 grid-flow-row overflow-hidden drop-shadow-md",
                ...className.split(" "),
            )}
            onClick={openRoomDetails}
        >
            <div className="col-span-4 relative p-4">
                <div className="w-full h-full">
                    {/* <ImageSlider images={images} useOldCloudinary={true}>
                        <div className="relative">
                            <Badges
                                lang={lang}
                                isInstantBooking={isInstantBooking}
                                isFeatured={isFeatured}
                                isSuperHost={isSuperHost}
                            />
                        </div>
                    </ImageSlider> */}
                    <CloudImage
                        key={img.url}
                        src={img.url}
                        loader={cloudinaryCoyotivLoader}
                        alt={img.title}
                        fill={true}
                        className="h-full object-cover select-none object-center w-96"
                        sizes="200px"
                        priority={true}
                    />
                </div>
            </div>
            {/* Explicit relative positioning is for a Safari fix https://myroom24.atlassian.net/browse/I2-300 */}
            <div className="relative col-span-6 p-4 bg-white flex flex-col justify-between">
                <div className="flex flex-row justify-between align-center max-w-[300px] whitespace-break-spaces">
                    <div className="flex flex-col">
                        {/* Removed due to business logic https://myroom24.atlassian.net/browse/I2-480 */}
                        {/* <div className="h-4">
                            <Text as="span" className="text-xs font-bold line-clamp-1" title={title}>
                                {title}
                            </Text>
                        </div> */}
                        <div className="h-4">
                            <Text as="span" className="text-xs font-bold line-clamp-1" title={category}>
                                {category}
                            </Text>
                        </div>
                        <div className="h-3">
                            <Text as="span" className="text-xxs text-gray-500 line-clamp-1">
                                {address}
                            </Text>
                        </div>
                    </div>
                    {/* <Text as="span" className="text-xxs text-gray-500">
                        <FontAwesomeIcon icon={faStar} className="text-primary-500 pr-1" size="lg" />
                        {rating}
                    </Text> */}
                </div>
                <div className="flex flex-col content-center">
                    <RoomInfo
                        lang={lang}
                        numBaths={numBaths}
                        numBedrooms={numBedrooms}
                        numBeds={numBeds}
                        numGuests={numGuests}
                        isMobile={true}
                        hasKitchen={hasKitchen} />
                </div>
                <div className="flex flex-row justify-between items-end">
                    <div className={itemBottomCss}>
                        {companyId === process.env.NEXT_PUBLIC_MYROOM24_COMPANY && (
                            <Text as="span" className="text-xs/none mr-2">
                                {t("room.from")}
                            </Text>
                        )}
                        <Text as="span" className="text-xl/none font-bold">
                            {lang === "en"
                                ? `${CurrencySymbol} ${PricewithoutCurrencySymbol}`
                                : PricewithCurrencySymbol}
                        </Text>
                        <Text as="span" className="text-xs/none">
                            /{t("room.month")}
                        </Text>
                    </div>
                    {originalPricePerMonth && (
                        <div className={itemBottomCss}>
                            <Text as="span" className="text-sm/none line-through">
                                {lang === "en"
                                    ? `${CurrencySymbol} ${Math.round(originalPricePerMonth / 100).toLocaleString(
                                        "de-DE",
                                    )}`
                                    : Math.round(originalPricePerMonth / 100).toLocaleString("de-DE", currencyStyle)}
                            </Text>
                        </div>
                    )}
                    {/*  <div className={itemBottomCss}>
                        <Text as="span" className="text-xs/none">
                             Available from 6th August
                        </Text>
                    </div>*/}
                    <div>
                        <div className="bg-primary-500 text-white h-6 w-6 flex justify-center items-center rounded">
                            <FontAwesomeIcon icon={faAngleRight} className="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileMapRoom;
